import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { HomeComponent } from '@shell/components/home/home.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, AuthRoutingModule, LoginComponent, LogoutComponent, HomeComponent],
})
export class AuthModule {}
